export default __webpack_public_path__ + "static/media/bg-top.70f7f2a1.png";